import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, useCallback, FormEventHandler } from 'react';
import { withBufferedValue } from '../../decorators/withBufferedValue/withBufferedValue';
import { prepareProps } from '../../utils/propUtils';
import { InputLayout, InputLayoutProps } from '../InputLayout/InputLayout';
import sharedStyles from '../sharedStyles.module.css';
export type NumberInputProps = Omit<InputLayoutProps, 'children' | 'onInput' | 'onChange' | 'onInputCapture' | 'onChangeCapture'> & {
  value: number | null | undefined;
  onInput: (value: number | null) => void;
};
export const NumberInput: FunctionComponent<NumberInputProps> = React.memo(props => {
  const $ = _c(14);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let onInput;
  let remainingProps;
  let value;
  if ($[2] !== t0) {
    ({
      value,
      onInput,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = onInput;
    $[4] = remainingProps;
    $[5] = value;
  } else {
    onInput = $[3];
    remainingProps = $[4];
    value = $[5];
  }
  let t1;
  if ($[6] !== onInput) {
    t1 = event => {
      const stringValue = event.currentTarget.value.trim();
      const numberValue = stringValue !== "" ? Number(stringValue) : NaN;
      onInput(isNaN(numberValue) ? null : numberValue);
    };
    $[6] = onInput;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const handleInput = t1;
  let t2;
  if ($[8] !== handleInput || $[9] !== value) {
    t2 = () => <input type="number" className={sharedStyles.inputBaseStyle} value={value !== null ? value : ""} onInput={handleInput} data-testid="NumberInput.input" />;
    $[8] = handleInput;
    $[9] = value;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== remainingProps || $[12] !== t2) {
    t3 = <InputLayout {...remainingProps}>{t2}</InputLayout>;
    $[11] = remainingProps;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
});
export const BufferedNumberInput = withBufferedValue(NumberInput);